import { useTranslation } from 'react-i18next';
// import { useState } from 'react';
import { CloseIcon } from '../../../assets/svgs/icons';
import styles from '../styles.module.css';

export const PreviewPage = ({
  preview,
  children,
  onClickTab,
  activeTab,
  canAccessArtsTab = true,
}) => {
  const { t } = useTranslation();
  // const [activeTab, setActiveTab] = useState('artes');

  if (!preview) return null;
  return (
    <div className={styles.preview}>
      <div className={styles.previewHeader}>
        <p className={styles.previewHeaderText}>{t('chatsocket.preview.title')}</p>
        <div className={styles.previewHeaderTabsContainer}>
          <div className={styles.previewHeaderTabs}>
            <button
              className={`${styles.previewTab} ${activeTab === 'artes' ? styles.previewTabActive : ''} ${!canAccessArtsTab ? styles.previewTabDisabled : ''}`}
              disabled={!canAccessArtsTab}
              title={!canAccessArtsTab ? t('chatsocket.preview.tab_disabled_tooltip') : ''}
              onClick={() => {
                if (!canAccessArtsTab) return;
                onClickTab && onClickTab('artes');
              }}
            >
              {t('chatsocket.preview.tab_arts')}
            </button>
            <button
              className={`${styles.previewTab} ${activeTab === 'estrategia' ? styles.previewTabActive : ''}`}
              onClick={() => {
                // setActiveTab('estrategia');
                onClickTab && onClickTab('estrategia');
              }}
            >
              {t('chatsocket.preview.tab_strategy')}
            </button>
          </div>
          {/* <button className={styles.previewCloseButton}>
            <CloseIcon color="#000000" size="27" />
          </button> */}
        </div>
      </div>
      <div className={styles.previewContent}>
        {children}
      </div>
    </div>
  );
};
